import { IConsentPartnerInfo } from "@/app/endpoints/healthComparatorEndpoints"

const formatPartner = ({ label, orias }: IConsentPartnerInfo) => (orias ? `${label} (ORIAS n° ${orias})` : label)

// « A », « A ou B », « A, B ou C » : the legal mention names every partner allowed to call the prospect
export const formatPartnerList = (partners: IConsentPartnerInfo[]) => {
    const names = partners.map(formatPartner)
    if (names.length === 1) return names[0]
    return `${names.slice(0, -1).join(", ")} ou ${names[names.length - 1]}`
}
